export default "__VITE_ASSET__DRV3A69c__"